import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faClock,
  faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import TabBar from '../components/TabBar';
import '../styles/Iletisim.css';
import { HiPhone, HiMail, HiLocationMarker, HiOfficeBuilding, HiCalendar, HiUser, HiChat, HiLockClosed, HiRefresh, HiCheckCircle } from 'react-icons/hi';

const Iletisim: React.FC = () => {
  const navigate = useNavigate();
  const [mapLoaded, setMapLoaded] = useState(false);
  
  // Form state'leri
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  // CAPTCHA için state
  const [captcha, setCaptcha] = useState('');
  const [userCaptcha, setUserCaptcha] = useState('');
  const [showCaptchaError, setShowCaptchaError] = useState(false);
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const [formSubmitSuccess, setFormSubmitSuccess] = useState(false);
  
  // İletişim bilgileri
  const contactInfo = {
    company: 'İstanbul Havalimanı Taksi Kooperatifi',
    phone: '+90 850 780 7734',
    whatsapp: '+90 850 780 7734',
    email: 'bilgi@havalimanitaksi.com.tr',
    address: 'İmrahor Mahallesi Vecihi Hürkuş Caddesi No:1/1, Arnavutköy-İstanbul',
  };

  // CAPTCHA oluşturma fonksiyonu
  const generateCaptcha = () => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let captchaText = '';
    for (let i = 0; i < 6; i++) {
      captchaText += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(captchaText);
  };

  // Sayfa yüklendiğinde CAPTCHA oluştur
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Form input değişiklik işleyicisi
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // CAPTCHA input değişiklik işleyicisi
  const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserCaptcha(e.target.value);
    setShowCaptchaError(false);
  };

  // Form gönderme işleyicisi
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // CAPTCHA doğrulama
    if (userCaptcha !== captcha) {
      setShowCaptchaError(true);
      return;
    }
    
    setIsFormSubmitting(true);
    
    // Form gönderme simülasyonu
    setTimeout(() => {
      setIsFormSubmitting(false);
      setFormSubmitSuccess(true);
      
      // Form datalarını temizle
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setUserCaptcha('');
      
      // Yeni CAPTCHA oluştur
      generateCaptcha();
      
      // Başarı mesajını 3 saniye sonra kaldır
      setTimeout(() => {
        setFormSubmitSuccess(false);
      }, 3000);
    }, 1500);
  };

  // WhatsApp'a yönlendirme
  const handleWhatsapp = () => {
    window.open(`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}`, '_blank');
  };

  // Telefon araması
  const handleCall = () => {
    window.location.href = `tel:${contactInfo.phone.replace(/\D/g, '')}`;
  };

  // E-posta gönderme
  const handleEmail = () => {
    window.location.href = `mailto:${contactInfo.email}`;
  };

  // Haritada göster
  const handleMap = () => {
    window.open('https://maps.google.com/?q=İmrahor+Mahallesi+Vecihi+Hürkuş+Caddesi+No:1/1,+Arnavutköy-İstanbul', '_blank');
  };

  return (
    <div className="iletisim-container" style={{ paddingTop: 70 }}>
      <Header title="İletişim" />
      
      <Container className="iletisim-content py-4">
        <Row className="mb-5">
          <Col lg={6}>
            <Card className="iletisim-card">
              <Card.Body>
                <h3 className="card-title mb-4">İletişim Bilgileri</h3>
                <div className="iletisim-bilgileri">
                  <div className="bilgi-item">
                    <div className="bilgi-icon">
                      <FontAwesomeIcon icon={faPhone} />
                    </div>
                    <div className="bilgi-content">
                      <h4>Telefon</h4>
                      <p>+90 (212) 123 45 67</p>
                    </div>
                  </div>
                  
                  <div className="bilgi-item">
                    <div className="bilgi-icon">
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <div className="bilgi-content">
                      <h4>E-posta</h4>
                      <p>info@ihlmobil.com</p>
                    </div>
                  </div>
                  
                  <div className="bilgi-item">
                    <div className="bilgi-icon">
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </div>
                    <div className="bilgi-content">
                      <h4>Adres</h4>
                      <p>İstanbul Havalimanı, Arnavutköy/İstanbul</p>
                    </div>
                  </div>
                  
                  <div className="bilgi-item">
                    <div className="bilgi-icon">
                      <FontAwesomeIcon icon={faClock} />
                    </div>
                    <div className="bilgi-content">
                      <h4>Çalışma Saatleri</h4>
                      <p>7/24 Hizmet</p>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={6}>
            <Card className="iletisim-card">
              <Card.Body>
                <h3 className="card-title mb-4">Bize Ulaşın</h3>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adınız Soyadınız</Form.Label>
                    <Form.Control type="text" placeholder="Adınız Soyadınız" required />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>E-posta Adresiniz</Form.Label>
                    <Form.Control type="email" placeholder="ornek@email.com" required />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Telefon Numaranız</Form.Label>
                    <Form.Control type="tel" placeholder="(5XX) XXX XX XX" />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Konu</Form.Label>
                    <Form.Control type="text" placeholder="Mesajınızın konusu" required />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Mesajınız</Form.Label>
                    <Form.Control as="textarea" rows={5} placeholder="Mesajınızı buraya yazın..." required />
                  </Form.Group>
                  
                  <Button type="submit" className="submit-button">
                    <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                    Gönder
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        
        <Row>
          <Col>
            <Card className="harita-card">
              <Card.Body>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.4434567890123!2d28.7319944!3d41.2750785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7040068086b%3A0xe1ccfe98bc01b0d0!2zxLBzdGFuYnVsIEhhdmFsaW1hbsSx!5e0!3m2!1str!2str!4v1234567890"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      
      <TabBar />
    </div>
  );
};

export default Iletisim; 